import { Accordion } from "@gcs/design-system/react";
import styled from "styled-components";

export const TabsContainer = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "60px",
}));

export const TabsList = styled.div(() => ({
  display: "flex",
  justifyContent: "space-between",
  overflowX: "auto",
}));

export const TabsTrigger = styled.button(({ theme, $isActiveTab }) => ({
  flex: 1,
  fontSize: "16px",
  fontWeight: "700",
  padding: "16px 8px",
  border: "none",
  cursor: "pointer",
  color: $isActiveTab ? theme.color.brandPrimary.light : "inherit",
  borderBottom: `4px solid ${$isActiveTab ? "#40BCFF" : "transparent"}`,
  background: "transparent",
  filter: "brightness(100%)",
  transition: "all .1s ease-in-out",

  [theme.breakpoint.xl()]: {
    fontSize: "18px",
    paddingTop: "32px",
    paddingBottom: "32px",
  },
}));

export const TabsAccordion = styled(Accordion.Item)(({ theme }) => ({
  p: {
    fontSize: '18px',
  }
}))

export const TabsAccordionContent = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));
